import { Paths } from "../../constants/UrlConstants";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
import {
  travelOrEapModules,
  nonHowToClaimsModules
} from "../../constants/SMEModulesToMatchOn";

export const defaultLinks = [
  { Text: "My claims", Link: Paths.Claims },
  { Text: "Make a claim", Link: Paths.MakeAClaim },
  { Text: "How to claim", Link: Paths.HowToClaim },
  { Text: "Provide medical consent", Link: Paths.MedicalConsent }
];

export const getClaimsWrapperNavLinks = (currentPolicy = {}) => {
  let links = [...defaultLinks];
  if (currentPolicy.IsInternational) {
    links[3] = { Text: "Specialist appointment booking service", Link: Paths.FastTrack };
  } else if (currentPolicy.IsFormat2) {
    links.push({ Text: "Specialist appointment booking service", Link: Paths.Appointments });
  }
  if (
    currentPolicy.IsSMEModular &&
    !shouldShowIfAllSMEModulesDontMatch(currentPolicy, travelOrEapModules)
  ) {
    links = [{ Text: "How to claim", Link: Paths.HowToClaim }];
  }
  if (
    currentPolicy.IsSMEModular &&
    !shouldShowIfAllSMEModulesDontMatch(currentPolicy, nonHowToClaimsModules)
  ) {
    links.splice(2, 1);
  }
  return links;
};
